export const toKebabCase = (camelCaseString: string | number = ''): string => {
  const words = camelCaseString.toString().match(/([A-Z][a-z]+)|(\d+)|([a-z]+)|([A-Z]+)/g) || [
    camelCaseString,
  ];
  return words.join('-').toLowerCase();
};
